import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const propTypes = {
  defaultValue: PropTypes.string,
  handleChange: PropTypes.func,
};

export default function SearchForm(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { defaultValue, handleChange } = props;

  return (
    <div>
      <Row>
        <Col md={{ span: 12, offset: 0 }}>
          <div className="keyword-search highlight-box">
            <label className="keyword-search__label" htmlFor="searchbox">
              Keyword Search
            </label>
            <input
              className="keyword-search__input"
              id="searchbox"
              defaultValue={defaultValue}
              onChange={handleChange}
              placeholder="Enter search term"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
